import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Routes, Route } from "react-router-dom";
import { AppPolycaikTheme } from "./containers/theme/theme";
import { LandingPage } from "./containers/landing/Landing";
import { ContributorPage } from "./containers/contributor/Contributor";
import { DeveloperPage } from "./containers/developer/developer";
import { CompanyPage } from "./containers/company/Company";
import { FaqPage } from "./containers/faq/Faq";
import { TermsPage } from "./containers/terms/Terms";
import { PrivacyPage } from "./containers/privacy/Privacy";

function App() {
  return (
    <ThemeProvider theme={AppPolycaikTheme}>
      <CssBaseline />
      <Routes>
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/contributors" element={<ContributorPage />} />
        <Route path="/developers" element={<DeveloperPage />} />
        <Route path="/FAQ" element={<FaqPage />} />
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </ThemeProvider>
  );
}
export default App;
